import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";
import { type CbhFeatureFlags } from "@src/appV2/FeatureFlags/CbhFeatureFlags";

export default function useVisitRateSettingConfiguration(): CbhFeatureFlags[CbhFeatureFlag.CONFIGURE_VISIT_RATE_SETTING] {
  return useCbhFlag(CbhFeatureFlag.CONFIGURE_VISIT_RATE_SETTING, {
    defaultValue: { enabled: false },
  });
}
